module.exports = __webpack_public_path__ + "img/bp_yq2_dis.2caf8e20.png";